import { Skeleton } from '@/components/ui/skeleton';
import { PageHeaderSkeleton } from './PageHeaderSkeleton';
import { PageWrapper } from '@/components/layout';
import { Card, CardContent, CardHeader } from '@/components/ui/card';

/**
 * Skeleton for the FindYourLegislator page.
 * Reserves layout space to prevent CLS.
 *
 * Layout breakdown:
 * - PageHeader with breadcrumbs + description: ~130px
 * - Address form card (header + 4 fields + button): ~340px
 */
export function FindYourLegislatorPageSkeleton() {
  return (
    <PageWrapper header={<PageHeaderSkeleton showBreadcrumbs={true} showDescription={true} />}>
      <div className="py-8">
        <div className="max-w-3xl mx-auto space-y-8">
          {/* Address Lookup Form Card */}
          <Card>
            <CardHeader>
              <div className="flex items-center gap-2">
                <Skeleton className="h-5 w-5" />
                <Skeleton className="h-6 w-40" />
              </div>
              <Skeleton className="h-4 w-72 mt-1.5" />
            </CardHeader>
            <CardContent className="space-y-4">
              {/* Street Address */}
              <div className="space-y-2">
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-10 w-full" />
              </div>

              {/* City / State / ZIP row */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="space-y-2">
                  <Skeleton className="h-4 w-10" />
                  <Skeleton className="h-10 w-full" />
                </div>
                <div className="space-y-2">
                  <Skeleton className="h-4 w-12" />
                  <Skeleton className="h-10 w-full" />
                </div>
                <div className="space-y-2">
                  <Skeleton className="h-4 w-16" />
                  <Skeleton className="h-10 w-full" />
                </div>
              </div>

              {/* Submit button */}
              <Skeleton className="h-10 w-full" />
            </CardContent>
          </Card>
        </div>
      </div>
    </PageWrapper>
  );
}
